import IService from "@api/iService";
import { IConsumerGift, IGiftGroup, IGiftGroupShort, ISearchGiftGroup } from "@interfaces/consumer/daily";
import { PatchDailyGiftModel, PatchGiftGroupModel, PutDailyGiftModel, PutGiftGroupModel, SearchGiftGroupModel } from "@models/consumer/daily";
import { PanelTableDataModel } from "@models/panel";
import { PanelTableData } from "@interfaces/panel";

export default class ConsumerDailyService extends IService {

    async getGifts() {
        return await this.getApi<IConsumerGift[]>('/api/consumer/daily/gift/');
    }

    fetchGiftsList = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IConsumerGift[]>>('/api/consumer/daily/gift/', model)
    }

    async getGift(id: string) {
        return await this.getApi<IConsumerGift>(`/api/consumer/daily/gift/${id}/`);
    }

    async putBalanceGift(model: PutDailyGiftModel) {
        return await this.putApi<IConsumerGift>('/api/consumer/daily/gift/balance/', model);
    }

    async putItemGift(model: PutDailyGiftModel) {
        return await this.putApi<IConsumerGift>('/api/consumer/daily/gift/item/', model);
    }

    async patchBalanceGift(model: PatchDailyGiftModel) {
        return await this.patchApi<IConsumerGift>('/api/consumer/daily/gift/balance/', model);
    }

    async patchItemGift(model: PatchDailyGiftModel) {
        return await this.patchApi<IConsumerGift>('/api/consumer/daily/gift/item/', model);
    }

    async getGiftGroup(id: string) {
        return await this.getApi<IGiftGroup>(`/api/consumer/daily/group/${id}/`);
    }

    fetchGiftGroupsList = async (model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IGiftGroupShort[]>>('/api/consumer/daily/group/', model)
    }

    async putGiftGroup(model: PutGiftGroupModel) {
        return await this.putApi<IGiftGroup>('/api/consumer/daily/group/', model);
    }

    async patchGiftGroup(model: PatchGiftGroupModel) {
        return await this.patchApi<IGiftGroup>('/api/consumer/daily/group/', model);
    }

    async deleteGiftGroup(id: string) {
        return await this.deleteApi(`/api/consumer/daily/group/${id}/`);
    }

    async searchGiftGroup(model: SearchGiftGroupModel) {
        return await this.postApi<ISearchGiftGroup[]>('/api/consumer/daily/group/search/', model);
    }
}